new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoArea.classList.contains('default')) {
                var $carouselShow = $('.gallery-thumb-carrousel-show'); // mostra 2
                var $carouselNav = $('.gallery-thumb-carrousel-nav');   // mostra 4

                // Carrossel principal (mostra 2 por vez)
                $carouselShow.slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    adaptiveHeight: true,
                    asNavFor: '.gallery-thumb-carrousel-nav' // sincroniza com o outro
                });

                // Carrossel secundário (mostra 4 por vez)
                $carouselNav.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    vertical: true,
                    asNavFor: '.gallery-thumb-carrousel-show', // sincroniza com o outro
                    focusOnSelect: true, // permite clique para selecionar
                    arrows: true,
                    dots: false,
                    infinite: false
                });
            }

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                } else if (photoArea.classList.contains('gallery-carrousel')) {
                    var $carouselShow = $('.gallery-thumb-carrousel-show');
                    var $carouselNavItems = $('.gallery-thumb-carrousel-nav li');

                    $carouselShow.slick({
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        dots: true,
                        infinite: false,
                        adaptiveHeight: true
                    });

                    // Clique na nav para ir para o slide correspondente
                    $carouselNavItems.each(function (index) {
                        $(this).on('click', function () {
                            $carouselShow.slick('slickGoTo', index);
                        });
                    });

                    // Atualiza classe active na thumb correspondente
                    $carouselShow.on('afterChange', function (event, slick, currentSlide) {
                        $carouselNavItems.removeClass('active');
                        $carouselNavItems.eq(currentSlide).addClass('active');
                    });

                    // Ativa a primeira ao iniciar
                    $carouselNavItems.eq(0).addClass('active');
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        clickThumbsMosaic() {
            const thumbs = document.querySelector('.product-detail__header--photoArea-thumbs-default');
            const photos = document.querySelector('#product-photo ul');
            if (thumbs) {
                thumbs.addEventListener('click', function (event) {
                    if (event.target.classList.contains('product-detail__header--photoArea-mobile-img')) {
                        const eventPhoto = event.target.closest('.sp-wrap');
                        const targetPhoto = photos.querySelector(`#${eventPhoto.id}`);
                        if (targetPhoto) {
                            const offset = (window.innerHeight / 2) - (targetPhoto.offsetHeight / 2);
                            const elementPosition = targetPhoto.getBoundingClientRect().top + window.scrollY;

                            window.scrollTo({
                                top: elementPosition - offset,
                                behavior: 'smooth'
                            });
                        }
                    }
                })
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        },

        moveToBuy() {
            var productSize = document.querySelector(".product-detail__header--infoArea-variation");
            if (productSize) {
                productSize.scrollIntoView({ behavior: "smooth" });
            }
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();
        this.clickThumbsMosaic();
        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const label = document.querySelector('.product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    const haveKit = document.querySelector('.carousel-kit');
    if (haveKit) {
        (function () {
            document.addEventListener('click', function (event) {
                const colorItem = event.target.closest('.product__colors-item');
                if (!colorItem) return;

                const id = colorItem.dataset.id;
                if (!id) return;

                getInfo(event, id);
            });

            function getInfo(event, id) {
                axios.get(`/api/front/product/${id}/get-linked-product/`)
                    .then(res => {
                        const actualElement = event.target;

                        if (
                            $('.kitcolors')
                                .closest('.js_product_item_kit')
                                .siblings('.js-product_addons__product_detail_kit')
                                .length
                        ) {
                            $('.kitcolors')
                                .closest('.js_product_item_kit')
                                .siblings('.js-product_addons__product_detail_kit')
                                .remove();
                        }

                        const productItemKit = actualElement.closest('.product-item-kit');

                        productItemKit.querySelector('.is-selected')?.classList.remove('is-selected');
                        actualElement.closest('.product__colors-item').classList.add('is-selected');

                        productItemKit.setAttribute(
                            'data-product-item-kit-id',
                            res.data.id
                        );

                        productItemKit.querySelector('.name span').innerHTML = res.data.name;
                        productItemKit.querySelector('.name img').src = res.data.thumbnail;

                        const actualVariations = productItemKit.nextElementSibling;
                        actualVariations.innerHTML =
                            '<p class="label_attributes">Selecione o tamanho</p>';

                        let sizes = [];

                        for (let i = 0; i < res.data.variations.length; i++) {
                            const variation = res.data.variations[i];
                            if (variation.main_attribute) {
                                sizes.splice(
                                    variation.main_attribute.order,
                                    0,
                                    variation
                                );
                            }
                        }

                        for (let i = 0; i < sizes.length; i++) {
                            const size = sizes[i];
                            if (!size.main_attribute) continue;

                            const randomNumber = Math.floor(Math.random() * 99999999);
                            const stock = size.available === false ? 'out-of-stock' : '';

                            actualVariations.insertAdjacentHTML(
                                'beforeend',
                                `
                        <input
                            type="radio"
                            name="product_item_variation__product_detail__${res.data.id}_${randomNumber}"
                            id="product_item_variation__product_detail__${size.id}_${randomNumber}"
                            value="${size.id}"
                            data-variation-name="${size.main_attribute.name}"
                        >
                        <label
                            for="product_item_variation__product_detail__${size.id}_${randomNumber}"
                            class="label_radio ${stock} radio"
                        >
                            <span>${size.main_attribute.value}</span>
                        </label>
                        `
                            );
                        }

                        if (res.data.addons.length) {
                            const complements = document.createElement('div');
                            complements.id = `js-product_addons__product_detail_${id}`;
                            complements.className = 'complements';
                            complements.setAttribute('complements-for', id);
                            complements.innerHTML =
                                '<h2 class="complements-title">Complementos:</h2><br>';

                            for (let i = 0; i < res.data.addons.length; i++) {
                                const addon = res.data.addons[i];
                                const optional = addon.is_required ? 'False' : 'True';
                                const addonPrice = addon.price || '';

                                complements.insertAdjacentHTML(
                                    'beforeend',
                                    `
                            <label
                                class="complements-label-${addon.id}"
                                addon-id="${addon.id}"
                                addon-price="${addonPrice}"
                                data-addon-is-optional="${optional}"
                            >
                                ${addon.field_label}
                            </label>
                            `
                                );

                                if (addon.field_type === 'radio_options') {
                                    const select = document.createElement('select');
                                    select.name = `addon-${addon.id}`;
                                    select.id = `addon-select-${addon.id}`;

                                    addon.field_options.forEach(opt => {
                                        select.add(new Option(opt, opt));
                                    });

                                    const div = document.createElement('div');
                                    div.className = 'complements-content';
                                    div.appendChild(select);
                                    complements.appendChild(div);
                                }

                                if (addon.field_type === 'text') {
                                    const div = document.createElement('div');
                                    div.className = 'complements-content-area';
                                    div.innerHTML = `
                                <input
                                    name="addon-${addon.id}"
                                    type="text"
                                    maxlength="${addon.field_char_limit}"
                                >
                            `;
                                    complements.appendChild(div);
                                }
                            }

                            $('.kitcolors')
                                .closest('.itens-for-carousel')
                                .append(complements);
                        }

                        $('.kitcolors').height(
                            $('.kitcolors')
                                .closest('.itens-for-carousel')
                                .outerHeight()
                        );

                        $(productItemKit)
                            .siblings('.product-radio-variation')
                            .find('input')
                            .on('change', function () {
                                $(this)
                                    .siblings('input')
                                    .not(this)
                                    .prop('checked', false);
                            });
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        })();
    }



    let rotationDescription = document.querySelector('.product-detail__description');
    let rotationDescriptionNames = rotationDescription.querySelectorAll('.product-detail__description--names-item');
    let initDescription = rotationDescription.querySelectorAll('.product-detail__description--descriptions-item');
    initDescription = Array.from(initDescription);

    if (rotationDescription && rotationDescriptionNames.length && initDescription.length) {
        // Mantém o primeiro item sempre ativo
        initDescription[0].classList.add('active');
        rotationDescriptionNames[0].classList.add('active');

        rotationDescriptionNames.forEach((itemMenu, index) => {
            itemMenu.addEventListener('click', (e) => {
                e.preventDefault();

                // Impede que o primeiro item seja fechado
                if (index === 0) return;

                initDescription[index].classList.toggle('active');
                rotationDescriptionNames[index].classList.toggle('active');
            });
        });
    }

    // if (window.matchMedia("(min-width: 992px)").matches) {
    //     function animeScroll() {
    //         const photoScroll = document.querySelector('.product-detail__header--photoArea');
    //         const sidebarInner = document.querySelector('.sidebar__inner');

    //         if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
    //             const containerWidth = $('.product-detail__header--infoArea').width();
    //             const sidebarInnerHeight = sidebarInner.offsetHeight;
    //             const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
    //             const pageTop = window.pageYOffset;
    //             const rect = photoScroll.getBoundingClientRect();
    //             const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll

    //             if (pageTop > (offsetTop + totalHeight)) {
    //                 $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%' });
    //             } else if (pageTop > offsetTop) {
    //                 $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px' });
    //             } else {
    //                 $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%' });
    //                 $('.sidebar__inner').css({ paddingTop: '0' + 'px' });
    //             }
    //         }
    //     }

    //     window.addEventListener('scroll', function() {
    //         animeScroll();
    //     });

    //     animeScroll();
    // } 

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1.1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#like-carousel')) {
        $('#like-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 4,
                        arrows: true
                    }
                }
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        if ($('.product-rating__review-list')) {
            $('.product-rating__review-list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    }
                ]
            });
        }
    }

    $('#photo-fancy').fancybox();

    const buyTogether = document.querySelector('.product-detail__buy-together');

    if (buyTogether) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                    if (options) {
                                        options.classList.toggle('frente');
                                    }
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        if (options) {
                                            options.classList.toggle('frente');
                                        }
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                    }
                });
            });
        });

        observer.observe(buyTogether, {
            childList: true,
            subtree: true
        });

    }

    const photoAreaWrapper = document.querySelector('.product-detail__header--photoArea');
    const photoArea = document.querySelector('.product-detail__header--photoArea-thumbs-default');
    const header = document.querySelector('#app_header');

    function getDistanceFromTop(element) {
        if (!element) return 0;
        return element.offsetTop + getDistanceFromTop(element.offsetParent);
    }

    window.addEventListener('scroll', () => {
        const photoAreaWrapperHeight = photoAreaWrapper.offsetHeight;
        const photoAreaHeight = photoArea.offsetHeight;
        const headerAreaHeight = header.offsetHeight;

        const offsetTop = getDistanceFromTop(photoAreaWrapper);

        const scrollY = window.scrollY;

        const distance = offsetTop - headerAreaHeight;

        if (distance >= scrollY) {

            photoArea.style.top = `40px`;

        } else if (photoAreaWrapperHeight - photoAreaHeight <= scrollY - distance) {

            photoArea.style.top = `${photoAreaWrapperHeight - photoAreaHeight}px`;

        } else if (distance < scrollY) {

            photoArea.style.top = `${scrollY - distance}px`;

        }
    });
})